<template>
  <div data-css-scope="quasar" :class="bodyClasses">
    <QSelect v-bind="$attrs" ref="qRef" outlined :stack-label="true"></QSelect>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script lang="ts" setup>
import { defineExpose, onMounted, ref } from 'vue';
const qRef = ref();
const bodyClasses = ref();
const possibleClasses = [
  'body--dark',
  'body--light',
  'desktop',
  'mobile',
  'touch',
  'no-touch',
  'platform-android',
  'platform-ios',
  'native-mobile',
  'electron',
  'bex',
  'within-iframe',
];

onMounted(() => {
  const classList = Array.from(document.body.classList);
  bodyClasses.value = classList.filter(value => possibleClasses.includes(value));
});

const exposed = {};
const methods = [
  'scrollTo',
  'reset',
  'refresh',
  'resetValidation',
  'validate',
  'focus',
  'blur',
  'showPopup',
  'hidePopup',
  'removeAtIndex',
  'add',
  'toggleOption',
  'getOptionIndex',
  'setOptionIndex',
  'moveOptionSelection',
  'filter',
  'updateMenuPosition',
  'updateInputValue',
  'isOptionSelected',
  'getEmittingOptionValue',
  'getOptionValue',
  'getOptionLabel',
  'isOptionDisabled',
];
methods.forEach((methodName) => {
  const proxyFunction = (...params) => {
    return qRef.value[methodName](...params);
  }
  exposed[methodName] = proxyFunction;
})
defineExpose(exposed)
</script>
